
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-08-09-r3f-shader-material",
      function () {
        return require("private-next-pages/blogs/2025-08-09-r3f-shader-material/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-08-09-r3f-shader-material"])
      });
    }
  